var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundAboutEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1349,
    height: 362,
    fill: "none",
    viewBox: "0 0 1349 362",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 1349,
    height: 350,
    fill: "#286385",
    style: {
      fill: "#c73b24"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.9227 6.9618-5.9618-5.9618-5.9618 5.9618 5.9618 5.9618 5.9618-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.847 6.9618-5.9618-5.9618-5.9618 5.9618 5.9618 5.9618 5.9618-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.77 6.9618-5.961-5.9618-5.962 5.9618 5.962 5.9618 5.961-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.69 6.9618-5.962-5.9618-5.961 5.9618 5.961 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.62 6.9618-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.54 6.9618-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 6.9618-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.39 6.9618-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.31 6.9618-5.961-5.9618-5.962 5.9618 5.962 5.9618 5.961-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.24 6.9618-5.962-5.9618-5.961 5.9618 5.961 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.16 6.9618-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m830.08 6.9618-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m905.01 6.9618-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m979.93 6.9618-5.961-5.9618-5.962 5.9618 5.962 5.9618 5.961-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.9 6.9618-5.97-5.9618-5.96 5.9618 5.96 5.9618 5.97-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1129.8 6.9618-5.96-5.9618-5.96 5.9618 5.96 5.9618 5.96-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204.7 6.9618-5.96-5.9618-5.96 5.9618 5.96 5.9618 5.96-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1279.6 6.9618-5.96-5.9618-5.97 5.9618 5.97 5.9618 5.96-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1354.6 6.9618-5.96-5.9618-5.96 5.9618 5.96 5.9618 5.96-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.9227 93.886-5.9618-5.9618-5.9618 5.9618 5.9618 5.9618 5.9618-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.847 93.886-5.9618-5.9618-5.9618 5.9618 5.9618 5.9618 5.9618-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.77 93.886-5.961-5.9618-5.962 5.9618 5.962 5.9618 5.961-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.69 93.886-5.962-5.9618-5.961 5.9618 5.961 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.62 93.886-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.54 93.886-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 93.886-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.39 93.886-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.31 93.886-5.961-5.9618-5.962 5.9618 5.962 5.9618 5.961-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.24 93.886-5.962-5.9618-5.961 5.9618 5.961 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.16 93.886-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m830.08 93.886-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m905.01 93.886-5.962-5.9618-5.962 5.9618 5.962 5.9618 5.962-5.9618z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m979.93 93.886-5.961-5.9618-5.962 5.9618 5.962 5.9618 5.961-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.9 93.886-5.97-5.9618-5.96 5.9618 5.96 5.9618 5.97-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1129.8 93.886-5.96-5.9618-5.96 5.9618 5.96 5.9618 5.96-5.9618z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204.7 93.886-5.96-5.9618-5.96 5.9618 5.96 5.9618 5.96-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1279.6 93.886-5.96-5.9618-5.97 5.9618 5.97 5.9618 5.96-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1354.6 93.886-5.96-5.9618-5.96 5.9618 5.96 5.9618 5.96-5.9618z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.9227 180.81-5.9618-5.962-5.9618 5.962 5.9618 5.962 5.9618-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.847 180.81-5.9618-5.961-5.9618 5.961 5.9618 5.962 5.9618-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.77 180.81-5.961-5.961-5.962 5.961 5.962 5.962 5.961-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.69 180.81-5.962-5.961-5.961 5.961 5.961 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.62 180.81-5.962-5.961-5.962 5.961 5.962 5.962 5.962-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.54 180.81-5.962-5.961-5.962 5.961 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 180.81-5.962-5.961-5.962 5.961 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.39 180.81-5.962-5.961-5.962 5.961 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.31 180.81-5.961-5.961-5.962 5.961 5.962 5.962 5.961-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.24 180.81-5.962-5.961-5.961 5.961 5.961 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.16 180.81-5.962-5.961-5.962 5.961 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m830.08 180.81-5.962-5.961-5.962 5.961 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m905.01 180.81-5.962-5.961-5.962 5.961 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m979.93 180.81-5.961-5.961-5.962 5.961 5.962 5.962 5.961-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.9 180.81-5.97-5.961-5.96 5.961 5.96 5.962 5.97-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1129.8 180.81-5.96-5.962-5.96 5.962 5.96 5.962 5.96-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204.7 180.81-5.96-5.962-5.96 5.962 5.96 5.962 5.96-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1279.6 180.81-5.96-5.962-5.97 5.962 5.97 5.962 5.96-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1354.6 180.81-5.96-5.962-5.96 5.962 5.96 5.962 5.96-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.9227 267.73-5.9618-5.962-5.9618 5.962 5.9618 5.962 5.9618-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.847 267.73-5.9618-5.962-5.9618 5.962 5.9618 5.962 5.9618-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.77 267.73-5.961-5.962-5.962 5.962 5.962 5.962 5.961-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.69 267.73-5.962-5.962-5.961 5.962 5.961 5.962 5.962-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.62 267.73-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.54 267.73-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 267.73-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.39 267.73-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.31 267.73-5.961-5.962-5.962 5.962 5.962 5.962 5.961-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.24 267.73-5.962-5.962-5.961 5.962 5.961 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.16 267.73-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m830.08 267.73-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m905.01 267.73-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m979.93 267.73-5.961-5.962-5.962 5.962 5.962 5.962 5.961-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.9 267.73-5.97-5.962-5.96 5.962 5.96 5.962 5.97-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1129.8 267.73-5.96-5.962-5.96 5.962 5.96 5.962 5.96-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204.7 267.73-5.96-5.962-5.96 5.962 5.96 5.962 5.96-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1279.6 267.73-5.96-5.962-5.97 5.962 5.97 5.962 5.96-5.962z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1354.6 267.73-5.96-5.962-5.96 5.962 5.96 5.962 5.96-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.9227 354.66-5.9618-5.962-5.9618 5.962 5.9618 5.962 5.9618-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.847 354.66-5.9618-5.962-5.9618 5.962 5.9618 5.962 5.9618-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.77 354.66-5.961-5.962-5.962 5.962 5.962 5.962 5.961-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.69 354.66-5.962-5.962-5.961 5.962 5.961 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.62 354.66-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.54 354.66-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 354.66-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.39 354.66-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.31 354.66-5.961-5.962-5.962 5.962 5.962 5.962 5.961-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.24 354.66-5.962-5.962-5.961 5.962 5.961 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.16 354.66-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m830.08 354.66-5.962-5.962-5.962 5.962 5.962 5.962 5.962-5.962z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m905.01 354.66-5.962-5.962-5.962 5.962 5.962 5.961 5.962-5.961z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m979.93 354.66-5.961-5.962-5.962 5.962 5.962 5.961 5.961-5.961z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1054.9 354.66-5.97-5.962-5.96 5.962 5.96 5.961 5.97-5.961z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1129.8 354.66-5.96-5.962-5.96 5.962 5.96 5.961 5.96-5.961z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204.7 354.66-5.96-5.962-5.96 5.962 5.96 5.961 5.96-5.961z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1279.6 354.66-5.96-5.962-5.97 5.962 5.97 5.961 5.96-5.961z",
    stroke: "white",
    strokeWidth: 0.63075
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1354.6 354.66-5.96-5.962-5.96 5.962 5.96 5.961 5.96-5.961z",
    stroke: "white",
    strokeWidth: 0.63075
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundAboutEon);
export default __webpack_public_path__ + "static/media/background_aboutEON.ac6485d979303727b87bfc5dfc16d2cd.svg";
export { ForwardRef as ReactComponent };